import React from "react";

const timeColors = [
  "text-blue-500",
  "text-green-500",
  "text-teal-500",
  "text-orange-500",
  "text-purple-500",
];

const OngoingAnalysesTable = ({ data = [] }) => (
  <div className="bg-white rounded-2xl border border-surface-border p-4 sm:p-6 flex flex-col gap-4">
    <h2 className="text-base font-bold text-brand-text">Ongoing Analysis</h2>
    <div className="overflow-x-auto -mx-1">
      <table className="w-full text-sm min-w-[360px]">
        <thead>
          <tr className="border-b border-surface-border">
            <th className="text-left text-xs font-medium text-brand-muted pb-3 pr-4 whitespace-nowrap">Software Name</th>
            <th className="text-left text-xs font-medium text-brand-muted pb-3 pr-4">Privacy URL</th>
            <th className="text-left text-xs font-medium text-brand-muted pb-3 pr-4 whitespace-nowrap">Date</th>
            <th className="text-left text-xs font-medium text-brand-muted pb-3 w-full whitespace-nowrap">Estimated Time</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
                <td colSpan={4} className="py-8 text-center text-sm text-brand-muted">
                No ongoing analyses.
              </td>
            </tr>
          ) : data.map((row, i) => (
            <tr key={i} className="border-b border-surface-border last:border-0">
              <td className="py-3.5 pr-4 font-semibold text-brand-text whitespace-nowrap">{row.company}</td>
               <td className="py-3.5 pr-4">
                 <span className="block max-w-[220px] truncate text-brand-muted text-xs" title={row.privacyUrl || ""}>{row.privacyUrl || "—"}</span>
               </td>
              <td className="py-3.5 pr-4 text-brand-muted whitespace-nowrap">{row.date}</td>
              <td className={`py-3.5 text-left font-semibold whitespace-nowrap w-full ${timeColors[i % timeColors.length]}`}>
                {row.estimatedTime}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default OngoingAnalysesTable;
